//TODO: Make this a regular enum. Parse it from json.
export const productType = {
  Catalog: 'Catalog',
  Brochure: 'Brochure',
  Bulletin: 'Bulletin',
  Seed: 'Seed',
  Postcard: 'Postcard', 
  Poster: 'Poster'
};

export type ProductType = 'Catalog' | 'Brochure' | 'Bulletin' | 'Seed' | 'Postcard' | 'Poster';



// WEBPACK FOOTER //
// ./src/infrastructure/ProductType.ts